import { render, staticRenderFns } from "./ftRegister.vue?vue&type=template&id=6724e2e1&scoped=true&"
import script from "./ftRegister.vue?vue&type=script&lang=js&"
export * from "./ftRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724e2e1",
  null
  
)

export default component.exports